import { render, staticRenderFns } from "./project-wrapper.vue?vue&type=template&id=2613329f&scoped=true&"
import script from "./project-wrapper.vue?vue&type=script&lang=js&"
export * from "./project-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./project-wrapper.vue?vue&type=style&index=0&id=2613329f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613329f",
  null
  
)

component.options.__file = "project-wrapper.vue"
export default component.exports